// Pool of random manager names (nautical-themed, international)

const FIRST_NAMES = [
  'Erik', 'Ingrid', 'Hans', 'Sofia', 'Mikael', 'Katarina',
  'Anders', 'Astrid', 'Olaf', 'Helena', 'Lars', 'Nadia',
  'Marco', 'Isabella', 'Chen', 'Yuki', 'Rajesh', 'Priya',
  'Jorge', 'Carmen', 'Dimitri', 'Svetlana', 'Kwame', 'Amara',
  'Bjorn', 'Freya', 'Sven', 'Elsa', 'Gunnar', 'Sigrid',
  'Takeshi', 'Mei', 'Abdul', 'Fatima', 'Jean', 'Marie',
  'Nikolai', 'Petra', 'Diego', 'Rosa', 'Tobias', 'Linnea'
];

const LAST_NAMES = [
  'Lindström', 'Petersen', 'Nakamura', 'Vasquez', 'Okonkwo',
  'Andersen', 'Johansson', 'Bergström', 'Madsen', 'Karlsson',
  'Morales', 'Santiago', 'Chen', 'Tanaka', 'Patel',
  'Fischer', 'Reyes', 'Volkov', 'Diallo', 'Svensson',
  'Borg', 'Nilsen', 'Christensen', 'Larsen', 'Olsen',
  'da Silva', 'Torres', 'Kim', 'Hassan', 'Dubois',
  'Weber', 'Rossi', 'Müller', 'Santos', 'Eriksson'
];

/** Generate a random manager name using a seed-compatible approach */
export function generateManagerName(rng = Math.random) {
  const first = FIRST_NAMES[Math.floor(rng() * FIRST_NAMES.length)];
  const last  = LAST_NAMES[Math.floor(rng() * LAST_NAMES.length)];
  return `${first} ${last}`;
}
